export const HOME = {
  emergentLink: "emergent-link",
};

export const APP = {
  tabGenerator: "tab-generator",
  tabInventory: "tab-inventory",
  tabHost: (id) => `tab-host-${id}`,
  tabHostClose: (id) => `tab-host-close-${id}`,
};

export const GEN = {
  countInput: "gen-count-input",
  generateBtn: "gen-generate-btn",
  copyAllBtn: "gen-copy-all-btn",
  copyRowBtn: (i) => `gen-copy-row-${i}`,
  regenRowBtn: (i) => `gen-regen-row-${i}`,
  outputList: "gen-output-list",
};

export const INV = {
  search: "inv-search-input",
  clearSearch: "inv-clear-search-btn",
  showFavoritesToggle: "inv-favorites-toggle",
  filterType: "inv-filter-type",
  filterTier: "inv-filter-tier",
  filterEnv: "inv-filter-env",
  filterOs: "inv-filter-os",
  resetFilters: "inv-reset-filters-btn",
  row: (id) => `inv-row-${id}`,
  favoriteBtn: (id) => `inv-fav-${id}`,
  sortHeader: (col) => `inv-sort-${col}`,
  connectBtn: (id) => `inv-connect-${id}`,
  serviceNowBtn: (id) => `inv-snow-${id}`,
  datadogBtn: (id) => `inv-datadog-${id}`,
  locationCell: (id) => `inv-location-${id}`,
  connectDialog: "inv-connect-dialog",
  connectCopyBtn: "inv-connect-copy-btn",
  emptyState: "inv-empty-state",
  rowCount: "inv-count",
};

export const DETAIL = {
  root: (id) => `detail-${id}`,
  hostSection: "detail-section-host",
  haSection: "detail-section-ha",
  locationSection: "detail-section-location",
  systemSection: "detail-section-system",
  field: (key) => `detail-field-${key}`,
  peer: (i) => `detail-peer-${i}`,
  backBtn: (id) => `detail-back-${id}`,
};
